import React, { useState, useMemo } from 'react';
import { ChevronDown, ChevronUp, Mic, Radio, Tv, Globe, Building, Phone, GraduationCap, Minus, Plus } from 'lucide-react';

// ========== DATA ==========
const VOICE_CATEGORIES = [
  {
    id: 'broadcast',
    name: 'Publicidad Comercial & Broadcast',
    icon: Radio,
    color: 'from-red-500 to-orange-500',
    items: [
      { id: 'radio_nacional', name: 'Radio Tradicional — Nacional', price: 4500, unit: 'spot' },
      { id: 'radio_regional', name: 'Radio Tradicional — Regional', price: 3600, unit: 'spot' },
      { id: 'radio_local', name: 'Radio Tradicional — Local', price: 2250, unit: 'spot' },
      { id: 'tv_nacional', name: 'Televisión Abierta — Nacional', price: 8000, unit: 'spot' },
      { id: 'tv_regional', name: 'Televisión Abierta — Regional', price: 5000, unit: 'spot' },
      { id: 'tv_local', name: 'Televisión Abierta — Local', price: 4000, unit: 'spot' },
      { id: 'tv_latam', name: 'TV Pan Cable / LATAM', price: 24000, unit: 'spot' },
      { id: 'cine_nacional', name: 'Cine — Nacional', price: 6000, unit: 'spot' },
    ]
  },
  {
    id: 'digital',
    name: 'Medios Digitales y Streaming',
    icon: Globe,
    color: 'from-blue-500 to-cyan-500',
    items: [
      { id: 'radio_internet', name: 'Radio por Internet (No Streaming)', price: 4500, unit: 'proyecto' },
      { id: 'radio_streaming', name: 'Radio por Internet (Streaming Live)', price: 5000, unit: 'proyecto' },
      { id: 'web_sitio', name: 'Internet / Web — Sitio Cliente', price: 3000, unit: 'proyecto' },
      { id: 'web_preroll', name: 'Internet / Web — Pre Roll', price: 5000, unit: 'proyecto' },
      { id: 'web_red_social', name: 'Internet / Web — Red Social', price: 3000, unit: 'red' },
      { id: 'video_explicativo', name: 'Video Promocional Explicativo (hasta 90s)', price: 8000, unit: 'proyecto' },
      { id: 'yt_inst_1min', name: 'YouTube Institucional (hasta 1 min)', price: 5000, unit: 'proyecto' },
      { id: 'yt_talento_1min', name: 'YouTube Talento/Personaje (hasta 1 min)', price: 4500, unit: 'proyecto' },
      { id: 'yt_narracion_1min', name: 'YouTube Narración (hasta 1 min)', price: 8000, unit: 'proyecto' },
      { id: 'yt_inst_5min', name: 'YouTube Institucional (3 a 5 min)', price: 8000, unit: 'proyecto' },
      { id: 'yt_talento_5min', name: 'YouTube Talento/Personaje (3 a 5 min)', price: 8000, unit: 'proyecto' },
      { id: 'yt_narracion_5min', name: 'YouTube Narración (3 a 5 min)', price: 12000, unit: 'proyecto' },
      { id: 'paq_social', name: 'Paquete Full Social Media', price: 8000, unit: 'paquete' },
      { id: 'paq_web', name: 'Paquete Full Web (uso ilimitado)', price: 15000, unit: 'paquete' },
    ]
  },
  {
    id: 'institucional',
    name: 'Imagen Institucional (Igualas Mensuales)',
    icon: Building,
    color: 'from-purple-500 to-indigo-500',
    items: [
      { id: 'iguala_radio_local', name: 'Radio — Local', price: 7000, unit: 'mes' },
      { id: 'iguala_radio_regional', name: 'Radio — Regional', price: 14000, unit: 'mes' },
      { id: 'iguala_radio_nacional', name: 'Radio — Nacional', price: 28000, unit: 'mes' },
      { id: 'iguala_tv_nacional', name: 'TV Abierta — Nacional', price: 20000, unit: 'mes' },
      { id: 'iguala_tv_intl', name: 'TV Abierta — Internacional', price: 30000, unit: 'mes' },
      { id: 'iguala_tv_paga', name: 'TV Paga — Nacional', price: 12000, unit: 'mes' },
      { id: 'iguala_tv_paga_intl', name: 'TV Paga — Internacional', price: 35000, unit: 'mes', note: 'USD $1,500-$2,000' },
      { id: 'iguala_tv_cultural', name: 'TV Paga — Canal Cultural', price: 8000, unit: 'mes' },
    ]
  },
  {
    id: 'non_broadcast',
    name: 'Non-Broadcast, Corporativo y Entretenimiento',
    icon: Tv,
    color: 'from-emerald-500 to-teal-500',
    items: [
      { id: 'maquetas', name: 'Maquetas / Animatics', price: 3000, unit: 'unidad' },
      { id: 'circuito_cerrado', name: 'Circuito Cerrado', price: 3000, unit: 'spot' },
      { id: 'video_interno_min', name: 'Video Interno — Minuto inicial', price: 3000, unit: 'minuto' },
      { id: 'video_interno_extra', name: 'Video Interno — Minuto extra', price: 1500, unit: 'minuto' },
      { id: 'voces_productos', name: 'Voces para Productos (por frase)', price: 2000, unit: 'frase' },
      { id: 'videojuegos', name: 'Videojuegos / Audiolibros (por hora)', price: 1750, unit: 'hora' },
      { id: 'mobile_5min', name: 'Mobile Game Apps (hasta 5 min)', price: 7500, unit: 'proyecto', note: 'USD $350-$500' },
      { id: 'mobile_5min_plus', name: 'Mobile Game Apps (más de 5 min)', price: 12000, unit: 'proyecto', note: 'USD $600' },
      { id: 'pantallas_pos', name: 'Pantallas POS (Presencial)', price: 3500, unit: 'spot' },
      { id: 'perifoneo', name: 'Perifoneo', price: 4000, unit: 'spot' },
      { id: 'aerolineas', name: 'Aerolíneas — Mensajes a bordo', price: 1750, unit: 'mensaje', note: 'USD $50-$100' },
      { id: 'aviso_corto', name: 'Aviso de Privacidad — Corto', price: 2000, unit: 'proyecto' },
      { id: 'aviso_extenso', name: 'Aviso de Privacidad — Extenso', price: 3500, unit: 'proyecto' },
      { id: 'trailer_general', name: 'Trailers de Películas — General', price: 7000, unit: 'proyecto' },
      { id: 'trailer_internet', name: 'Trailers de Películas — Internet', price: 5000, unit: 'proyecto' },
      { id: 'trailer_ambas', name: 'Trailers de Películas — Ambas', price: 12000, unit: 'proyecto' },
      { id: 'podcast_intro', name: 'Podcasts — Intro/Outro', price: 5000, unit: 'proyecto' },
      { id: 'infomercial_principal', name: 'Infomercial — Personaje Principal (5 min)', price: 8000, unit: 'proyecto' },
      { id: 'infomercial_secundario', name: 'Infomercial — Secundario (5 min)', price: 5000, unit: 'proyecto' },
      { id: 'infomercial_incidental', name: 'Infomercial — Incidental/Breve (5 min)', price: 2500, unit: 'proyecto' },
    ]
  },
  {
    id: 'ivr_elearning',
    name: 'IVR y E-Learning',
    icon: Phone,
    color: 'from-amber-500 to-yellow-500',
    items: [
      { id: 'ivr_bienvenida', name: 'IVR — Mensaje de Bienvenida', price: 3500, unit: 'mensaje' },
      { id: 'ivr_menu', name: 'IVR — Menú Individual', price: 800, unit: 'menú' },
      { id: 'ivr_espera', name: 'IVR — Mensaje de Espera/Hold', price: 2600, unit: 'mensaje' },
      { id: 'elearn_session', name: 'E-Learning — Session Free', price: 5500, unit: 'sesión', note: 'USD $250-$300' },
      { id: 'elearn_5min', name: 'E-Learning — Garantizada 5 min', price: 6000, unit: 'sesión', note: 'USD $300' },
      { id: 'elearn_15min', name: 'E-Learning — Garantizada 15 min', price: 16000, unit: 'sesión', note: 'USD $800' },
      { id: 'elearn_20min', name: 'E-Learning — Garantizada 20 min', price: 20000, unit: 'sesión', note: 'USD $1,000' },
      { id: 'elearn_45min', name: 'E-Learning — Garantizada 45 min', price: 24000, unit: 'sesión', note: 'USD $1,200' },
      { id: 'elearn_60min', name: 'E-Learning — Garantizada 60 min', price: 30000, unit: 'sesión', note: 'USD $1,500' },
    ]
  }
];

// ========== SUB-COMPONENTS ==========
function QuantityControl({ quantity, onChange, testIdPrefix }) {
  return (
    <div className="flex items-center gap-1">
      <button
        onClick={(e) => { e.stopPropagation(); onChange(Math.max(0, quantity - 1)); }}
        className="w-6 h-6 rounded bg-white/10 hover:bg-white/20 flex items-center justify-center text-slate-400 hover:text-white transition-colors"
        data-testid={`${testIdPrefix}-decrease`}
      >
        <Minus className="w-3 h-3" />
      </button>
      <span className="w-8 text-center text-white font-bold text-sm" data-testid={`${testIdPrefix}-quantity`}>{quantity}</span>
      <button
        onClick={(e) => { e.stopPropagation(); onChange(quantity + 1); }}
        className="w-6 h-6 rounded bg-white/10 hover:bg-white/20 flex items-center justify-center text-slate-400 hover:text-white transition-colors"
        data-testid={`${testIdPrefix}-increase`}
      >
        <Plus className="w-3 h-3" />
      </button>
    </div>
  );
}

function ServiceItem({ item, quantity, onQuantityChange, formatPrice, currency }) {
  const isActive = quantity > 0;
  return (
    <div
      className={`flex items-center justify-between p-3 rounded-lg border transition-all ${
        isActive
          ? 'border-[#aa2aff]/40 bg-[#aa2aff]/10'
          : 'border-white/5 bg-white/[0.02] hover:bg-white/[0.04]'
      }`}
    >
      <div className="flex-1 min-w-0 mr-3">
        <p className={`text-sm font-medium truncate ${isActive ? 'text-white' : 'text-slate-300'}`}>
          {item.name}
        </p>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="text-xs text-[#aa2aff] font-semibold">
            {formatPrice(item.price)} / {item.unit}
          </span>
          {item.note && <span className="text-xs text-slate-500">({item.note})</span>}
          {isActive && (
            <span className="text-xs text-green-400 font-bold">
              = {formatPrice(item.price * quantity)}
            </span>
          )}
        </div>
      </div>
      <QuantityControl quantity={quantity} onChange={onQuantityChange} testIdPrefix={`voice-${item.id}`} />
    </div>
  );
}

function CategorySection({ category, quantities, onQuantityChange, formatPrice, currency, isOpen, onToggle }) {
  const Icon = category.icon;
  const categoryTotal = category.items.reduce((sum, item) => sum + item.price * (quantities[item.id] || 0), 0);
  const activeCount = category.items.filter(item => (quantities[item.id] || 0) > 0).length;

  return (
    <div className="border border-white/10 rounded-xl overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-3 hover:bg-white/5 transition-colors"
        data-testid={`btn-toggle-voice-category-${category.id}`}
      >
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${category.color} flex items-center justify-center`}>
            <Icon className="w-4 h-4 text-white" />
          </div>
          <div className="text-left">
            <span className="text-white font-medium text-sm block">{category.name}</span>
            {activeCount > 0 && (
              <span className="text-xs text-green-400 font-bold">
                {activeCount} servicio{activeCount > 1 ? 's' : ''} — {formatPrice(categoryTotal)} {currency}
              </span>
            )}
          </div>
        </div>
        {isOpen ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {isOpen && (
        <div className="p-3 pt-0 space-y-2">
          {category.items.map(item => (
            <ServiceItem
              key={item.id}
              item={item}
              quantity={quantities[item.id] || 0}
              onQuantityChange={(qty) => onQuantityChange(item.id, qty)}
              formatPrice={formatPrice}
              currency={currency}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// ========== MAIN COMPONENT ==========
export function VoiceServicesSection({ isOpen, onToggle, quantities, onQuantityChange, formatPrice, currency }) {
  const [openCategories, setOpenCategories] = useState({});

  const toggleCategory = (catId) => {
    setOpenCategories(prev => ({ ...prev, [catId]: !prev[catId] }));
  };

  const { total, itemCount, selectedItems } = useMemo(() => {
    let total = 0;
    let itemCount = 0;
    const selectedItems = [];
    VOICE_CATEGORIES.forEach(cat => {
      cat.items.forEach(item => {
        const qty = quantities[item.id] || 0;
        if (qty > 0) {
          total += item.price * qty;
          itemCount++;
          selectedItems.push({ ...item, quantity: qty, subtotal: item.price * qty });
        }
      });
    });
    return { total, itemCount, selectedItems };
  }, [quantities]);

  return (
    <div className="border border-white/10 rounded-xl overflow-hidden bg-gradient-to-b from-[#1a1f50]/50 to-[#080c2d]/50" data-testid="voice-services-section">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
        data-testid="btn-toggle-voice-services"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#aa2aff] to-[#6b21a8] flex items-center justify-center">
            <Mic className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <span className="text-white font-semibold text-lg block">Servicios de Voz</span>
            {itemCount > 0 && (
              <span className="text-xs font-bold text-green-400">
                {itemCount} servicio{itemCount > 1 ? 's' : ''} — Total: {formatPrice(total)} {currency}
              </span>
            )}
          </div>
        </div>
        {isOpen ? <ChevronUp className="w-5 h-5 text-slate-400" /> : <ChevronDown className="w-5 h-5 text-slate-400" />}
      </button>

      {isOpen && (
        <div className="p-4 pt-0 space-y-3">
          {VOICE_CATEGORIES.map(cat => (
            <CategorySection
              key={cat.id}
              category={cat}
              quantities={quantities}
              onQuantityChange={onQuantityChange}
              formatPrice={formatPrice}
              currency={currency}
              isOpen={openCategories[cat.id] || false}
              onToggle={() => toggleCategory(cat.id)}
            />
          ))}
          {total > 0 && (
            <div className="flex justify-between items-center p-3 bg-[#aa2aff]/10 border border-[#aa2aff]/30 rounded-lg mt-2">
              <span className="text-white font-semibold text-sm">Subtotal Servicios de Voz</span>
              <span className="text-[#aa2aff] font-bold text-lg">{formatPrice(total)} {currency}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export { VOICE_CATEGORIES };
export default VoiceServicesSection;
